export default {
  black: '#0a0908',
  white: '#ffffff',

  neutral50: '#eae0d5',
  neutral100: '#d5cbbe',
  neutral200: '#c6ac8f',
  neutral300: '#a89279',
  neutral400: '#8a7a65',
  neutral500: '#5e503f',
  neutral600: '#4a3f32',
  neutral700: '#3a3128',
  neutral800: '#22333b',
  neutral900: '#161a1d',
  neutral950: '#0a0908',

  green: '#c6ac8f',
  greenBg: 'rgba(198,172,143,0.12)',
  greenBorder: 'rgba(198,172,143,0.3)',

  blue: '#5d79df',
  blueBg: 'rgba(93,121,223,0.1)',
  blueBorder: 'rgba(93,121,223,0.25)',

  purple: '#a89279',
  purpleBg: 'rgba(168,146,121,0.12)',
  purpleBorder: 'rgba(168,146,121,0.3)',

  orange: '#f36f1c',
  orangeBg: 'rgba(243,111,28,0.1)',
  orangeBorder: 'rgba(243,111,28,0.25)',

  red: '#eb524b',
  redBg: 'rgba(235,82,75,0.1)',
  redBorder: 'rgba(235,82,75,0.2)',

  amber: '#c6ac8f',
  amberBg: 'rgba(198,172,143,0.12)',
  amberBorder: 'rgba(198,172,143,0.3)',

  cyan: '#22333b',
  cyanBg: 'rgba(34,51,59,0.15)',
  cyanBorder: 'rgba(34,51,59,0.3)',

  surface: '#0a0908',
  surfaceMid: '#161a1d',
  surfaceCard: '#22333b',
  surfaceBorder: 'rgba(198,172,143,0.08)',
  surfaceBorderStrong: 'rgba(198,172,143,0.18)',
  text: '#eae0d5',
  textSoft: 'rgba(234,224,213,0.7)',
  textMuted: 'rgba(234,224,213,0.45)',
}
